import { DayOfWeek } from './day-of-week';
import { BookingSlot } from './booking-slot';
import { BookingInMemoryBookingSlotGenerator } from '../services/booking-in-memory.booking-slot-generator';
import { environment } from '../../../../environments/environment';

export class TimeRestriction {
  private _dayOfWeek: DayOfWeek;
  private _fromTime: number;
  private _toTime: number;
  private _areaItemId: number;
  private _slots = new Set<string>();
  private _fromDate: Date;
  private _toDate: Date;

  constructor(
    dayOfWeek: number,
    fromTime: number,
    toTime: number,
    areaItemId: number = -1,
    fromDate?: Date,
    toDate?: Date,
  ) {
    this._dayOfWeek = dayOfWeek;
    this._fromTime = fromTime;
    this._toTime = toTime;
    this._areaItemId = areaItemId;
    this._fromDate = fromDate;
    this._toDate = toDate;
  }

  static createFromAny(object: any): TimeRestriction {
    if (object === null || object === undefined) {
      return null;
    }

    return new TimeRestriction(
      object.dayOfWeek,
      object.fromTime,
      object.toTime,
      object.areaItemId,
      object.fromDate ? new Date(object.fromDate) : null,
      object.toDate ? new Date(object.toDate) : null,
    );
  }

  public get dayOfWeek(): DayOfWeek {
    return this._dayOfWeek;
  }

  public get fromTime(): number {
    return this._fromTime;
  }

  public get toTime(): number {
    return this._toTime;
  }

  public get areaItemId(): number {
    return this._areaItemId;
  }

  get slots(): Set<string> {
    if (!this._slots.size) {
      this._slots = new Set(
        BookingInMemoryBookingSlotGenerator.generateSlotIntervals(this.fromTime, this.toTime).map(timeInterval => {
          return environment.globalSettings.toTimeString(timeInterval[0]);
        }));
    }
    return this._slots;
  }

  public get fromDate(): Date {
    if (this._fromDate) {
      this._fromDate.setHours(0,0,0,0);
    }
    return this._fromDate;
  }

  public get toDate(): Date {
    if (this._toDate) {
      this._toDate.setHours(0,0,0,0);
    }
    return this._toDate;
  }

  public isDateValid(date): boolean {

    const validateDate = new Date(date);
    validateDate.setHours(0, 0, 0, 0);

    if (this.fromDate) {
      const fromDate = new Date(this.fromDate);
      fromDate.setHours(0, 0, 0, 0);
      if (fromDate > validateDate) {
        return false;
      }
    }

    if (this.toDate) {
      const toDate = new Date(this.toDate);
      toDate.setHours(0, 0, 0, 0);
      if (toDate < validateDate) {
        return false;
      }
    }

    return true;
  }
}

